import React from 'react';
import PropTypes from 'prop-types';
import { fileState } from '../../../utils/file-state';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';
import { formConstants } from '../../../utils/constants/form-constants';
import SSOCloseButton from '../../../common/utility/SSOCloseButton';

function FileSummary({
    orderItem,
    orderTypeValues,
    fileStateValues,
    onPrintSummaryButtonClick,
    onCancelButtonClick,
    onCloseButtonClick,
    onPayReservationClick,
    showCancelButton
}) {
    const {
        fileNumber,
        channel,
        status,
        created,
        formattedFileAmount,
        fileContact,
        orderType
    } = orderItem;

    function handleOnCancelClick(event) {
        event.preventDefault();
        onCancelButtonClick();
    }

    function handleOnPrintSummaryButtonClick(event) {
        event.preventDefault();
        onPrintSummaryButtonClick(fileNumber);
    }

    function handleOnPayReservationClick(event) {
        event.preventDefault();
        onPayReservationClick(fileNumber);
    }

    function isInReservation() {
        return status === formConstants.SecutixReservationStatus 
        || (orderType === formConstants.SecutixReservationOrderType
            && status === formConstants.SecutixReservationRunningStatus);
    }

    return (
        <div className='file-summary'>

            <SSOCloseButton onCloseButtonClick={onCloseButtonClick}></SSOCloseButton>
            <h2>{formMessageConstants.fileSummary}</h2>
            <div className='my-account-tag'>{orderTypeValues[orderItem.orderTypeIndex]}</div>
            <p>
                <span className='left'>{formMessageConstants.fileNumber}</span>
                <span className='right'>{fileNumber}</span>
            </p>
            <p>
                <span className='left'>{formMessageConstants.fileStatus}</span>
                <span className='right'>{fileStateValues[fileState[status]]}</span>
            </p>
            <p>
                <span className='left'>{formMessageConstants.fileContact}</span>
                <span className='right'>{fileContact}</span>
            </p>
            <p>
                <span className='left'>{formMessageConstants.fileAmount}</span>
                <span className='right'>{formattedFileAmount}</span>
            </p>
            <div className='buttons-container'>
                <a className='print-button' href='#' onClick={handleOnPrintSummaryButtonClick}>
                    <span className='ico'>
                        <svg aria-hidden='true'
                            focusable='false'
                            data-prefix='fal'
                            data-icon='print'
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 512 512'
                            className='icon-print'>
                            <path fill='white'
                                d='M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h80v112c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16V384h80c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM384 480H128v-96h256v96zm96-128H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z' className=''>
                            </path>
                        </svg>
                    </span>
                    <span className='text'>{formMessageConstants.printSummary}</span>
                </a>
                <a className='yellow-button' style={isInReservation() ? {} : { display: 'none' }} href='' onClick={handleOnPayReservationClick}>Pay the reservation</a>
                {showCancelButton && <a className='yellow-button' href='' onClick={handleOnCancelClick}>Cancel</a>}
            </div>
        </div >
    );
}

FileSummary.propTypes = {
    orderItem: PropTypes.object.isRequired,
    orderTypeValues: PropTypes.object.isRequired,
    fileStateValues: PropTypes.object.isRequired,
    onPrintSummaryButtonClick: PropTypes.func.isRequired,
    onPayReservationClick: PropTypes.func.isRequired,
    onCancelButtonClick: PropTypes.func.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired,
    showCancelButton: PropTypes.bool.isRequired
};


export default FileSummary;
